import React from 'react';
import { useLocation } from 'react-router-dom';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const location = useLocation();

  const hiddenPaths = [
    '/live-auction/',
    '/time-bid-auction/',
    '/close-bid-auction/',
    '/live-auction-public/',
    '/unit-lelang/'
  ];

  const shouldHide = hiddenPaths.some(path => location.pathname.includes(path));

  if (shouldHide) {
    return null;
  }

  const handleClick = () => {
    const encodedMessage = encodeURIComponent('Halo, saya ingin bertanya tentang Caready');
    window.open(`https://wa.me/6285891101162?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className="whatsapp-button" onClick={handleClick}>
      <div className="whatsapp-icon">
        <i className="mdi mdi-whatsapp"></i>
      </div>
      <span className="tooltip">Hubungi Kami</span>
    </div>
  );
};

export default WhatsAppButton;